import * as React from 'react';
import {withRouter} from 'react-router-dom';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import {PageTitleBar} from '../../layout';

import {EmailHeaderButtons} from '../email-header-buttons';

import {getTitles} from './get-titles';

type OwnProps = Record<any, any>;
type Props = OwnProps & ContextRouter;

class PageTitleBarContainer extends React.PureComponent<Props> {
    render() {
        const {pageTitle, pageSubTitle} = getTitles(this.props.location.pathname);

        return (
            <PageTitleBar
                title={pageTitle}
                subheaderPrimaryText={pageSubTitle}
                buttons={<EmailHeaderButtons />}
            />
        );
    }
}

// @ts-expect-error
export const EmailAutomationsTitleBar = withRouter<OwnProps>(PageTitleBarContainer);
